export const TYPES = {
  SELECT_ALL_TRACKING_SUCCESS: "time/SELECT_ALL_TRACKING_SUCCESS",
  SELECT_DATE_TRACKING_SUCCESS: "time/SELECT_DATE_TRACKING_SUCCESS",
};
